module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-mediumitalic-webfont.f61150aa.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-mediumitalic-webfont.woff
// module id = 380
// module chunks = 3